import React from 'react';
import HeroSection from '../components/HeroSection';
import MissionSnapshot from '../components/MissionSnapshot';
import ImpactCounter from '../components/ImpactCounter';
import StoriesCarousel from '../components/StoriesCarousel';
import OurWorkSection from '../components/OurWorkSection';
import DonationCTA from '../components/DonationCTA';
import CSRPartners from '../components/CSRPartners';
import TransparencySection from '../components/TransparencySection';

const HomePage = () => {
  return (
    <div className="pt-16">
      <HeroSection />
      <MissionSnapshot />
      <ImpactCounter />
      <StoriesCarousel />
      <OurWorkSection />
      <DonationCTA />
      <CSRPartners />
      <TransparencySection />
    </div>
  );
};

export default HomePage;